angular.module('bmsApp.trugreen.schedule')
	.factory('TGScheduleSvc', function ($q, $modal, $rootScope,
										CRUDSvc) {

			return {
				byDay: function (params) {
					return CRUDSvc.get('api/trugreen/schedule/byDay', params);
				},
				showMoveVisitModal: function (visitId, moveDate) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/trugreen/schedule/templates/MoveVisitModal.html',
						controller: 'TGMoveVisitModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							visitId: function () {
								return angular.copy(visitId);
							},
							moveDate: function() {
								return angular.copy(moveDate)
							}
						}
					});

					return modalInstance.result;
				},
				showMoveMultipleVisitsModal: function (employee) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/trugreen/schedule/templates/MoveMultipleVisitsModal.html',
						controller: 'TGMoveMultipleVisitsModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							employee: function () {
								return angular.copy(employee);
							}
						}
					});

					return modalInstance.result;
				},
				showBulkAssignVisitModal: function (start, end) {
					var params = {
						start: start,
						end: end
					};
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/trugreen/schedule/templates/BulkAssignVisitsModal.html',
						controller: 'TGBulkAssignVisitsModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							params: function () {
								return params;
							}
						}
					});

					return modalInstance.result;
				},
				showPreInvoiceAllModal: function (date, employees) {
					var params = {
						date: date,
						employees: employees
					};
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/trugreen/schedule/templates/PreInvoiceAllModal.html',
						controller: 'TGPreInvoiceAllModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							params: function () {
								return params;
							}
						}
					});

					return modalInstance.result;
				},
				preinvoiceBulk: function(visitIds) {
					return CRUDSvc.post('api/trugreen/visit/pre-invoice-bulk', visitIds);
				},
				moveVisit: function(params) {
					return CRUDSvc.post('api/trugreen/schedule/moveVisit', params);
				},
				moveMultipleVisits: function(params) {
					return CRUDSvc.post('api/trugreen/schedule/moveMultipleVisits', params);
				},
				bulkAssignVisits: function(params) {
					return CRUDSvc.post('api/trugreen/schedule/bulkAssignVisits', params);
				},
				showInventoryRequiredModal: function (date, employeeId) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/trugreen/schedule/templates/InventoryRequiredModal.html',
						controller: 'TGInventoryRequiredModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							date: function () {
								return angular.copy(date);
							},
							employeeId: function () {
								return angular.copy(employeeId);
							}
						}
					});

					return modalInstance.result;
				},
				inventoryRequired: function(params) {
					return CRUDSvc.get('api/trugreen/inventoryRequired', params);
				}
			};

		}
	)
;
